"use client";

import { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Error details:", error);
  }, [error]);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <div className="error-section">
            <h2 style={{ color: "#f33f33" }}>Error</h2>
            <h3>
              Ocurrio un error inesperado, contacte con el servicio de soporte!
            </h3>
            <p>Error:{error.message}</p>
            <p>ErrorName:{error.name}</p>
            <p>ErrorStack:{error.stack}</p>
            <p>ErrorDigest:{error.digest}</p>

            <div style={{ marginTop: "20px" }}>
              <button
                onClick={() => reset()}
                style={{ marginRight: "10px", padding: "8px 16px" }}
              >
                Intentar de nuevo
              </button>
              <button
                onClick={() => window.location.replace("/")}
                style={{ padding: "8px 16px" }}
              >
                Regresar
              </button>
            </div>
          </div>
        </Col>
        <Col className="d-flex justify-content-center align-items-center">
          <div className="error-container">{error.message}</div>
        </Col>
      </Row>
    </Container>
  );
}
